var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
// Define API base URL
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
// ----------------------
// Account Service Functions
// ----------------------
// Get Account Information
export const getAccountInformation = () => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.get(`${API_BASE_URL}/account`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
// Change Email
export const changeEmail = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.patch(`${API_BASE_URL}/account/email`, request, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
// Change Password
export const changePassword = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.patch(`${API_BASE_URL}/account/password`, request, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
// Download User Data
export const exportAccountData = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.get(`${API_BASE_URL}/account/export?format=${request.format}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        responseType: 'blob',
    });
    return response.data;
});
// Delete Account
export const deleteAccount = () => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.delete(`${API_BASE_URL}/account`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
// Re-send Verification Email
export const resendVerificationEmail = () => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.get(`${API_BASE_URL}/account/verification-email`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
// Verify email
export const verifyEmail = (verificationToken) => __awaiter(void 0, void 0, void 0, function* () {
    const token = localStorage.getItem('token');
    const response = yield axios.get(`${API_BASE_URL}/verify-email?token=${verificationToken}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    return response.data;
});
